import { Navigate, Route, Routes } from 'react-router-dom';
import { RequireAdmin, RequireAuth } from './auth/guards.tsx';
import { EditScreen } from './screens/EditScreen.tsx';
import { LoginScreen } from './screens/LoginScreen.tsx';
import { PlayerScreen } from './screens/PlayerScreen.tsx';
import { UploadScreen } from './screens/UploadScreen.tsx';
import { VideoListScreen } from './screens/VideoListScreen.tsx';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginScreen />} />

      <Route element={<RequireAuth />}>
        <Route path="/" element={<VideoListScreen />} />
        <Route path="/video/:id" element={<PlayerScreen />} />
      </Route>

      <Route element={<RequireAdmin />}>
        {/* Deliberately unlinked — reached by typing the URL. */}
        <Route path="/upload" element={<UploadScreen />} />
        {/* Linked, from the pencil on the player screen. */}
        <Route path="/video/:id/edit" element={<EditScreen />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
